import BasePlugin from './BasePlugin'

class ClientOnlyPlugin extends BasePlugin {
  static isClientOnly = true
  constructor(...args) {
    super(...args)
    this.clientOnly = true
  }
}

export default ClientOnlyPlugin